import React, { Component } from 'react';
import Datetime from 'react-datetime';
// import moment from 'moment';
import {FormBlocks} from './FormBlocks';
import 'react-datetime/css/react-datetime.css';
// import {getDateFormat} from '../../../../../Utils/UserFunctions';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
class TimePicker extends Component {
    
  onChangeDate = (moment)=>{
    if (typeof moment.format === "function") {
        this.props.onChangeInputAction({
          section_index:this.props.section.section_index,
          itemIndex:this.props.item.itemIndex,
          item:this.props.item,
        },moment.format('HH:MM:A'),'date')
      }else{
        this.props.onChangeInputAction({
          section_index:this.props.section.section_index,
          itemIndex:this.props.item.itemIndex,
          item:this.props.item,
        },'','date')
      }  
   }
     
  render() {
    const  {
      item,
      sectionType,
      validationForms,
      className
    } = this.props;
    
    const attr = formFieldsAttributes(
      {...item,className:className
    },validationForms,this.onChangeDate);

       return (
        <FormBlocks attr={attr} {...this.props} item={item} sectionType={sectionType}>
            <Datetime
                dateFormat={false}
                inputProps={attr.fieldAttributes}
                closeOnSelect={true}
                // value={attr.value}
                onChange={attr.onChange}
            />
       </FormBlocks>
    )
  }
}

TimePicker.defaultProps = {
  disabled: false,
  className:'form-control',
}

export default TimePicker;